import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsightHonest = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 329 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 15892",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_22",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 329,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 1243",
				width: 329,
				height: 24,
				fill: "var(--fill-0, #D9D9D9)"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_22)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M2 2L34.5 22L67 2L99.4975 22L131.992 2L164.492 22L196.992 2L229.492 22L261.992 2L294.497 22L327 2",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		})]
	})
});
export default SvgInsightHonest;
